import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverviewComponent } from './overview/overview.component';
import { Route } from '@angular/router';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {
  PagesV2Module,
  SpinnerV2Module,
  ModalModule,
  AssetsModule,
  TileV2Module,
  IconV2Module,
  ActionMenuV2Module,
  ButtonV2Module,
  SelectV2Module,
  InputV2Module,
  ChipV2Module,
  FileUploadV2Module,
  GridV2Module,
  NotificationsV2Module,
} from '@schenck/rotec-components';

import { MachineTileComponent } from './tile/machine-tile/machine-tile.component';
import { ToolingTileComponent } from './tile/tooling-tile/tooling-tile.component';
import { MachineDetailsModalComponent } from './machine-details-modal/machine-details-modal.component';
import { ToolingDetailsModalComponent } from './tooling-details-modal/tooling-details-modal.component';
import { TaskListComponent } from './task-list/task-list.component';

export const overviewRoutes: Route[] = [{ path: '', component: OverviewComponent }];

@NgModule({
  imports: [
    CommonModule,
    TranslatePipe,
    TranslateDirective,
    DragDropModule,
    ModalModule,
    PagesV2Module,
    AssetsModule,
    TileV2Module,
    IconV2Module,
    ActionMenuV2Module,
    SpinnerV2Module.forRoot(),
    SelectV2Module,
    InputV2Module,
    ChipV2Module,
    ButtonV2Module,
    FileUploadV2Module,
    GridV2Module,
    NotificationsV2Module,
    OverviewComponent,
    MachineTileComponent,
    ToolingTileComponent,
    MachineDetailsModalComponent,
    ToolingDetailsModalComponent,
    TaskListComponent,
  ],
})
export class OverviewModule {}
